export default {
    computed: {
        headers() {
            return [
                {
                    value: 'canteenName',
                    text: this.$t('labels.name'),
                    sortable: false,
                },
                {
                    value: 'budgetLimit',
                    text: this.$t('labels.budget'),
                    sortable: false,
                    width: 180,
                },
                {
                    value: 'budget',
                    text: this.$t('labels.balance'),
                    sortable: false,
                    width: 180,
                },
            ]
        },
    },
}
